import { Component, OnInit, OnDestroy } from '@angular/core';
import { CommonModule, Location } from '@angular/common';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { CompanyService } from 'app/services/company.service';
import { CompanyModel } from 'app/models/company.model';
import { BehaviorSubject, Observable, map, takeUntil } from 'rxjs';
import { Subject } from 'rxjs';
import { ApiService } from 'app/shared/apis/api.service';
import { UserModel } from 'app/models/user.model';

@Component({
    selector: 'company-selector',
    standalone: true,
    imports: [CommonModule, MatFormFieldModule, MatSelectModule, MatButtonModule, MatIconModule],
    template: `
        <ng-container *ngIf="(companies$ | async) as companies">
            <mat-form-field
                appearance="fill"
                class="w-full custom-height px-3 py-2"
                [subscriptSizing]="'dynamic'"
                [floatLabel]="'always'"
                *ngIf="companies.length > 0 && (currentCompanyId$ | async) !== null"
            >
                <mat-label>{{ isAdmin ? 'Selecionar Empresa' : 'Empresa' }}</mat-label>
                <mat-select
                    [value]="currentCompanyId$ | async"
                    (selectionChange)="onCompanyChange($event.value)"
                    [disabled]="!isAdmin"
                >
                    <mat-option *ngFor="let company of companies" [value]="company.company_id">
                        {{ company.title || 'Empresa ' + company.company_id }}
                    </mat-option>
                </mat-select>
            </mat-form-field>
        </ng-container>
    `,
    styles: [
        `
            :host {
                // display: inline-flex;
                // position: relative;
                // flex: 1 1 auto;
                // height: 44px;
                // mat-form-field.custom-height {
                //     background-color: transparent;
                //     height: 40px;
                //     min-height: 40px !important;
                // }

                // ::ng-deep .mat-mdc-form-field-flex {
                //     min-height: 40px !important;
                //     height: 40px;
                //     align-items: center;
                // }
                // ::ng-deep .mat-mdc-form-field-infix {
                //     min-height: 40px !important;
                //     height: 40px;
                // }

                // ::ng-deep .mat-mdc-text-field-wrapper {
                //     background-color: transparent;
                //     padding: 0 12px;
                //     height: 40px;
                //     min-height: 40px !important;
                // }
            }
        `,
    ],
})
export class CompanySelectorComponent implements OnInit, OnDestroy {
    private _companies = new BehaviorSubject<CompanyModel[]>([]);
    private _currentCompanyId = new BehaviorSubject<number | null>(null);
    private _unsubscribeAll: Subject<any> = new Subject<any>();

    companies$: Observable<CompanyModel[]> = this._companies.asObservable();
    currentCompanyId$: Observable<number | null> = this._currentCompanyId.asObservable();
    isAdmin: boolean = false;
    currentUser: UserModel | null = null;

    constructor(
        private companyService: CompanyService,
        private apiService: ApiService,
    ) {}

    ngOnInit(): void {
        ApiService.userCurrent
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe((user: UserModel) => {
                this.currentUser = user;
                this.isAdmin = user?.isAdmin || false;

                if (!this.isAdmin && user?.company?.company_id) {
                    // Usuário normal
                    const companyId = user.company.company_id;
                    this._currentCompanyId.next(companyId);
                    this._companies.next([user.company]);
                    this.companyService.setSelectedCompanyId(companyId);
                    return;
                }

                if (this.isAdmin) {
                    // ADMIN
                    this.loadAllCompaniesAndSelectDefault();
                }
            });
    }

    ngOnDestroy(): void {
        this._unsubscribeAll.next(null);
        this._unsubscribeAll.complete();
    }

    private loadAllCompaniesAndSelectDefault(): void {
        this.companyService.list({ limit: 'all' }).subscribe(response => {
            const companies = response.items || [];
            this._companies.next(companies);

            if (companies.length === 0) return;

            const savedCompanyId = localStorage.getItem('selectedCompanyId');
            let companyId: number;

            if (savedCompanyId) {
                companyId = Number(savedCompanyId);
            } else {
                companyId = companies[0].company_id; // primeira empresa como padrão
                localStorage.setItem('selectedCompanyId', companyId.toString());
            }

            this._currentCompanyId.next(companyId);
            this.companyService.setSelectedCompanyId(companyId);
        });
    }

    onCompanyChange(companyId: number): void {
        this._currentCompanyId.next(companyId);

        // Store selected company in localStorage for persistence
        localStorage.setItem('selectedCompanyId', companyId.toString());

        // Emit event or update service to notify other components
        // This will be used to filter all routes by company_id
        this.companyService.setSelectedCompanyId(companyId);

        window.location.reload()
    }
}
